<template lang="html">
  <div id="results-page">

    <section class="breadcrumb-section">
      <div class="container oversized-container px-lg-0">
        <span>Búsqueda</span>
        <span class="line">/</span>
        <span>{{ $route.query.keywords }}</span>
      </div>
    </section>

    <section class="container oversized-container products-section">
      <div class="row mb-3">
        <div class="col-12 col-s-title px-lg-0">
          <h2 class="title">Búsqueda: <small class="f-w-600">{{ $route.query.keywords }}</small></h2>
        </div>
      </div>

      <div class="row align-items-start">

        <!-- Mobile filters -->
         <div class="col-12 col-filters-mobile" v-if="false">
          <div class="bg-filter-mv" v-if="showFilters == true" @click="showFilters = false"></div>
          <a class="btn-filters" @click="showFilters = !showFilters">
            <i class="fas fa-filter"></i><span>Ver filtros</span>
          </a>
        </div>

        <div class="col-lg col-filters" v-bind:class="{ 'show-filters': showFilters == true }" v-if="false">
          <h4 class="_title">
            <span>Filtros de Búsqueda</span>
            <a class="btn-hide" @click="showFilters = false"><i class="fas fa-chevron-left"></i></a>
          </h4>

          <b-form class="filters-container" @submit="onSubmitFilters">

            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Categorías</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.brands"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="br.id" v-for="(br,indx) in brandsOpcs" :key="'bra'+indx">{{br.name}}</b-form-checkbox>

                </b-form-checkbox-group>
              </b-form-group>
            </div>

            <!-- <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Subcategoria</a>

              <b-form-group class="box-filters-group" v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  v-model="filtersForm.subcategories"
                  :aria-describedby="ariaDescribedby"
                  name="flavour-2">
                  <b-form-checkbox :value="subc.id" v-for="(subc,indx) in subcategoriesOpcs" :key="'subca'+indx">{{subc.name}}</b-form-checkbox>

                </b-form-checkbox-group>
              </b-form-group>
            </div> -->
            <div class="box-filters">
              <a class="btn-action"><i class="sy">-</i> Precio</a>

              <div class="box-filters-group">
                <b-form-select class="c-filter-select" v-model="filtersForm.price">
                  <b-form-select-option :value="null">Cualquiera</b-form-select-option>
                  <b-form-select-option :value="800">$1,000 o más</b-form-select-option>
                  <b-form-select-option :value="1499">$3,000 o más</b-form-select-option>
                  <b-form-select-option :value="999999999999999999">$4,500 o más</b-form-select-option>
                </b-form-select>
              </div>
            </div>

          </b-form>
        </div>
        <!--  -->

        <!-- Resultados en columnas -->
        <div class="col-lg col-products">
          <div class="row sample-products-wrapper">
            <div class="col-12 col-md-6 col-xl-4 px-sm-2 box-product-s1" v-for="(p, pInx) in products" :key="'pInx-'+pInx">
              <router-link class="box-link" :to="'/producto/'+$root._converToURL(p.name, p.id)">
                <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+p.image+')' }">
                  <img src="public/images/shared/empty.png">
                </div>

                <div class="box-info">
                  <h5 class="title">{{ p.name }}</h5>

                  <!-- <h5 class="price">DESDE ${{ p.price }}</h5> -->
                </div>
              </router-link>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12 text-center" v-if="!products.length && !isLoading">
              <h5>No se encontraron resultados</h5>
            </div>
          </div>
        </div>
        <!--  -->

      </div>

    </section>

    <div class="col-12" v-if="isLoading">
      <LoadingComponent></LoadingComponent>
    </div>

  </div>
</template>

<script>
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data(){
    return{
      isLoading: true,
      showFilters: false,

      filtersForm: {
        keywords: null,
        // brands:[],
        // subcategories:[],
        // price:null,
      },

      products: [
        // { image: 'public/images/pages/products/product-1.jpg', price: '50', name: 'Maceta de muestra tipo 1' },
      ],

      category: {
        name: null
      },
      category_id:null,
      brandsOpcs:[
        { id: 1, name: 'Maceta azalea' },
        { id: 2, name: 'Maceta colgante' },
        { id: 3, name: 'Macetas biodegradables' },
        { id: 4, name: 'Maceta tonalá' },
        { id: 5, name: 'Maceta venecia' },
        { id: 6, name: 'Maceta Deco-Art dunas' },
        { id: 7, name: 'Maceta Deco-Art acuario' },
      ],
      subcategoriesOpcs:[
        { id: 1, name: 'Subcategoría 1' },
      ],
    }
  },

  watch: {
    '$route.query.keywords':function(){
      this.getSearch();
    },

    // "filtersForm.brands" : function(v){
    //     // this.getProductsCategory(this.category_id);
    // },
    // "filtersForm.subcategories" : function(v){
    //     this.getProductsCategory(this.category_id);
    // },
    // "filtersForm.price" : function(v){
    //     this.getProductsCategory(this.category_id);
    // },
  },

  methods: {
    getSearch: function(){
      this.isLoading = true;
      this.filtersForm.keywords = this.$route.query.keywords;

      axios.post(tools.url('/api/products/search'),this.filtersForm).then((response) =>{
        this.products = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  mounted(){
    if(this.$route.query.keywords){
      this.getSearch();
    }
  },
}
</script>
